import React, {Component} from 'react';
import PropTypes from 'prop-types';
import QuickQuote from '~/js/components/global/QuickQuote';

export default class Card extends Component {
  static propTypes = {
    cardData: PropTypes.object
  }

  static defaultProps = {
    cardData: {}
  }

  state = {
    active: false
  }

  componentDidMount = () => {
    window.addEventListener('click', ev => this.clickWindow(ev));
    window.addEventListener('touchstart', ev => this.clickWindow(ev));
  }

  componentWillUnmount = () => {
    window.removeEventListener('click', ev => this.clickWindow(ev));
    window.removeEventListener('touchstart', ev => this.clickWindow(ev));
  }

  clickWindow = ev => {
    let evTarget = ev.target;

    while(!evTarget.classList.contains('courses-sort__popup')
      && evTarget !== document.body
      && !evTarget.classList.contains('courses-sort__card-btn')) {

      evTarget = evTarget.parentNode;

      if(evTarget.tagName === 'BODY') {
        this.closePopup();
        break;
      }
    }
  }

  togglePopup = () => {
    this.setState({active: !this.state.active});
  }

  closePopup = () => {
    this.setState({active: false});
  }

  render() {
    const {cardData} = this.props;
    const {active} = this.state;

    return(
      <div className="courses-sort__card">
        <img
          src={cardData.mainImages.thumbnail[0] || '#'}
          alt={'resort ' + cardData.rstCode}
          className="courses-sort__card-image" />

        <div className="courses-sort__card-name">
          <span>{cardData.eventName || 'Event Name'}</span>
        </div>

        <div className="courses-sort__price-wrap">
          <div className="courses-sort__price">
            ${cardData.rates[0].rate || '0'}
          </div>

          <div className="courses-sort__pcs">
            <div className="courses-sort__pcs-top">
              PER ADULT
            </div>

            <div className="courses-sort__pcs-bottom">
              (USD)
            </div>
          </div>
        </div>

        <div
          className="courses-sort__card-descr"
          dangerouslySetInnerHTML={{__html: (cardData.description && cardData.description.substring(0, 200) + '...') || ''}} />

        <a
          href={`/scuba/courses/details/?eventId=${cardData.eventId}&rstCode=${cardData.rstCode}` || '#'}
          className="courses-sort__card-link">
          Read more
        </a>

        <div className={'courses-sort__popup ' + (active ? 'courses-sort__popup--active' : '')}>
          <i
            className="icon-close"
            onClick={this.togglePopup} />
          <h3 className="qq-ttl opensans-semibold">Enter your vacation details</h3>
          <QuickQuote
            schedulerModeIndex={ 4 }
            hasCountries={ false }
            brand="beaches"
            noLabels
            hasOccupancy={ false }
            reference="oee"
            defaultResortCode={ cardData.rstCode }
            eventID={ cardData.eventId }
            groupID={ cardData.groupId }
            occupancyLabels={ false }
            schedulerModeIndex={ 12 }
            quoteButtonText="Continue"
            className="qq landing qq-popover"
            startDatePlaceholderText="Check In Date"
            endDatePlaceholderText="Check Out Date"
            notOeeRequest
            numberOfMonths={ 1 }
            confirmationNumber
          />
        </div>

        <button
          className="courses-sort__card-btn"
          onClick={this.togglePopup}>
          Book Now
        </button>
      </div>
    );
  }
}
